export type MediationAgreementReportsListType = {
  id: number;
  company_name: string;
  seller_name: string;
  created_at: string;
  expiry_date: string;
  contract_status: string;
  status: keyof typeof MediationAgreementReportsStatus;
  chat_room_id?: number;
  is_expired: boolean;
};

export type MediationAgreementReportDataType = {
  created_at: string;
  id: number;
  chat_room_id: number;
  offline_seller_property_id: number | null;
  seller_name: string;
  owner_name: string;
  company_name: string;
  category: keyof typeof MediationAgreementReportsCategory;
  effective_date: string;
  expiry_date: string;
  files?: { id: number; file_name: string }[];
  file_id?: number;
  file_name?: string;
  note: string;
  contract_amount: number;
  destroyable: boolean;
  renewal_count: number;
  termination_reason: keyof typeof MediationAgreementReportsTerminationReasons | null;
  status: keyof typeof MediationAgreementReportsStatus;
  is_expired: boolean;
};

export type UpdateMediationAgreementReportDateType = {
  contract_amount: string;
  chat_room_id: number;
};

export const MediationAgreementReportPropertyType = {
  mansion: 'マンション',
  land: '土地',
  used_house: '中古戸建て',
  other: 'その他',
};

export const MediationAgreementReportsCategory = {
  non_exclusive: '一般媒介契約',
  exclusive: '専任媒介契約',
  privileged_and_exclusive: '専属専任媒介契約',
};

export const MediationAgreementReportsStatus = {
  listed: '契約中',
  expired: '契約終了',
  sold: '売買契約締結済み',
  unknown: '不明',
};

export const MediationAgreementReportsTerminationReasons = {
  sold_by_other_company: '他社で成約した',
  switched_to_other_company: '他社に媒介を乗り換えた',
  listing_expired: '媒介契約の期限を迎え、更新しなかった',
  rented_out: '賃貸として貸し出すことになった',
  sale_canceled: '売却を中止した',
  sale_on_hold: '売却を一時的に保留している',
};

export const PostMediationAgreementReportsTerminationReasons = {
  sold: '売買契約を締結した',
  ...MediationAgreementReportsTerminationReasons,
};

export type MediationAgreementReportsCategoryKey = keyof typeof MediationAgreementReportsCategory;
